<template>
  <div class="page_container">
    <div class="tree_container">
      <a-tree
        v-if="provinceTreeData.length > 0"
        blockNode
        checkable
        defaultExpandAll
        :tree-data="provinceTreeData"
        :checkedKeys="treeCheckedKeys"
        @check="handleProvinceTreeDataItemCheck"
        @select="treeSelect"
      >
        <template #title="{ title, schoolCount }">
          <div class="tree_title_container">
            <div class="tree_title_target">{{ title }}</div>
            <div class="tree_title_sub">
              <span>（</span>
              <span class="number">{{ schoolCount }}</span>
              <span>）</span>
            </div>
          </div>
        </template>
      </a-tree>
    </div>
    <div class="body_container">
      <div class="header_container">
        <h3 class="title">当前选中：</h3>
        <p class="content">
          {{ selectSchoolListResultTextStart }}
          <span class="number">{{ selectSchoolListResult.length }}</span>
          所学校
        </p>
      </div>
      <div class="search_container">
        <div class="search_container_left">
          <a-input v-model:value="searchKeywords" placeholder="搜索学校名称" @keyup.enter="handleSearchKeywords">
            <template #suffix>
              <img
                src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/4f335c6bd8924a9980e301ed818df3c5.png"
                alt="搜索"
                style="cursor: pointer"
                @click="handleSearchKeywords"
              />
            </template>
          </a-input>
          <a-select
            :default-value="''"
            @change="handleStatus"
            placeholder="状态"
            style="width: 240px; margin-left: 16px"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          >
            <a-select-option :value="item.value" v-for="item in statusOptions" :key="item.value">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </div>
        <div class="search_container_right">
          <p class="export_btn" @click="handleExport">导出运行数据</p>
          <p class="add_btn" @click="handleAdd">
            <img
              src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/9978dd0fa3a547218af711c7fe2cc7b4.png"
              alt="+"
              class="icon"
            />
            <span>新增机构</span>
          </p>
        </div>
      </div>
      <div class="list_container">
        <a-table
          :columns="schoolColumns"
          :data-source="schoolList"
          :pagination="pagination"
          :loading="loading"
          :row-key="(record) => record.schoolCode"
          @change="handleTableChange"
        >
          <div slot="status" slot-scope="text, record" class="status_box">
            <div class="no_in_use" v-if="record.status === 0">
              <span class="dot"></span>
              <span class="title">未启用</span>
            </div>
            <div class="in_use" v-if="record.status === 1">
              <span class="dot"></span>
              <span class="title">启用中</span>
            </div>
            <div class="forbidden" v-if="record.status === 2">
              <span class="dot"></span>
              <span class="title">禁用中</span>
            </div>
          </div>
          <div slot="action" slot-scope="text, record" class="action_box">
            <span v-if="record.status !== 1" @click="handleEnable('startusing', record.schoolCode)">启用</span>
            <span v-if="record.status === 1" @click="handleEnable('forbidden', record.schoolCode)">禁用</span>
          </div>
        </a-table>
      </div>
    </div>
    <addorupdate-organizational
      :addOrUpdateOrganizationalDialogFlag.sync="addOrUpdateOrganizationalDialogFlag"
      :provinceList="provinceList"
      :provinceListAll="provinceListAll"
      @getSchoolList="getSchoolList"
    />
    <forbidden-startusing
      :forbiddenStartUsingDialogFlag.sync="forbiddenStartUsingDialogFlag"
      :forbiddenStartUsingDialogType="forbiddenStartUsingDialogType"
      :forbiddenStartUsingDialogSchoolCode="forbiddenStartUsingDialogSchoolCode"
      @getSchoolList="getSchoolList"
    />
  </div>
</template>

<script>
import DateUtil from '@/utils/getDate.js'
export default {
  name: 'OrganizationalManagement',
  components: {
    'addorupdate-organizational': () => import('./comp/AddOrUpdateOrganizational.vue'),
    'forbidden-startusing': () => import('./comp/ForbiddenStartUsing.vue')
  },
  data() {
    return {
      provinceList: [],
      provinceTreeData: [],
      treeCheckedKeys: [],
      schoolCountTotal: 0,
      searchKeywords: '',
      statusOptions: [
        {
          title: '全部',
          value: ''
        },
        {
          title: '未启用',
          value: 0
        },
        {
          title: '启用中',
          value: 1
        },
        {
          title: '禁用中',
          value: 2
        }
      ],
      status: '',
      schoolColumns: [
        {
          title: '学校ID',
          dataIndex: 'schoolCode',
          key: 'schoolCode',
          scopedSlots: { customRender: 'schoolCode' },
          align: 'left'
        },
        {
          title: '所属省份',
          dataIndex: 'provinceName',
          key: 'provinceName',
          scopedSlots: { customRender: 'provinceName' },
          align: 'left'
        },
        {
          title: '学校名称',
          dataIndex: 'schoolName',
          key: 'schoolName',
          scopedSlots: { customRender: 'schoolName' },
          align: 'left'
        },
        {
          title: '接入教室数',
          dataIndex: 'classroomCount',
          key: 'classroomCount',
          scopedSlots: { customRender: 'classroomCount' },
          align: 'left'
        },
        {
          title: '开通时间',
          dataIndex: 'openingDate',
          key: 'openingDate',
          scopedSlots: { customRender: 'openingDate' },
          align: 'left'
        },
        {
          title: '到期时间',
          dataIndex: 'expiredDate',
          key: 'expiredDate',
          scopedSlots: { customRender: 'expiredDate' },
          align: 'left'
        },
        {
          title: '最近开课时间',
          dataIndex: 'lastLiveTime',
          key: 'lastLiveTime',
          scopedSlots: { customRender: 'lastLiveTime' },
          align: 'left'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'left',
          width: '100px'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'left',
          width: '80px'
        }
      ],
      schoolList: [],
      addOrUpdateOrganizationalDialogFlag: false,
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['50', '100', '150', '200'],
        showTotal: (total) => `共 ${total} 条`
      },
      loading: false,
      forbiddenStartUsingDialogType: '',
      forbiddenStartUsingDialogFlag: false,
      forbiddenStartUsingDialogSchoolCode: '',
      selectSchoolListResult: [],
      provinceListAll: []
    }
  },
  computed: {
    selectSchoolListResultTextStart: function () {
      let res = ''
      if (this.selectSchoolListResult.length > 1) {
        res =
          this.selectSchoolListResult
            .slice(0, 2)
            .map((item) => item.schoolName)
            .join('、') + '等'
      } else {
        this.selectSchoolListResult.map((item) => item.schoolName).join('、') + '等'
      }
      return res
    }
  },
  methods: {
    disposeProvinceTreeData(provinceTreeData) {
      const provinceTreeDataNew = provinceTreeData.map((item) => {
        if (item.children && item.children.length) {
          this.disposeProvinceTreeData(item.children)
        }
        item.title = item.provinceName
        item.key = item.provinceId
        this.schoolCountTotal += item.schoolCount
        return item
      })
      return provinceTreeDataNew
    },
    async getProvinceTreeData() {
      try {
        const result = await this.$http.schoolProvinces()
        if (result.code !== 200) return
        this.schoolCountTotal = 0
        this.provinceTreeData = [
          {
            title: '省份',
            key: 'all',
            children: this.disposeProvinceTreeData(result.rt || []),
            schoolCount: this.schoolCountTotal
          }
        ]
        this.treeCheckedKeys = this.provinceTreeData[0].children.map((v) => v.key)
        this.provinceList = this.provinceTreeData[0].children
        this.getSchoolBatchSchoolByProvinceId()
      } catch (err) {
        console.log(err)
      }
    },
    async getProvinceListAll() {
      try {
        const result = await this.$http.areaTree()
        if (result.code !== 200) return
        this.provinceListAll = result.rt
          .filter((item) => item.level === 0)
          .map((item) => {
            item.title = item.name
            item.key = item.id
            return item
          })
      } catch (err) {
        console.log(err)
      }
    },
    handleProvinceTreeDataItemCheck(checkedKeys) {
      this.treeCheckedKeys = checkedKeys
      this.getSchoolList()
      if (this.treeCheckedKeys.length) {
        this.getSchoolBatchSchoolByProvinceId()
      } else {
        this.selectSchoolListResult = []
      }
    },
    treeSelect(selectedKeys, e) {
      e.node.onExpand()
    },
    async getSchoolList() {
      try {
        const params = {
          provinceIds: this.treeCheckedKeys.filter((item) => item !== 'all'),
          keywords: this.searchKeywords,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        if (this.status !== '') {
          Object.assign(params, {
            status: this.status
          })
        }
        this.loading = true
        const result = await this.$http.schoolSearchByPage(params)
        this.loading = false
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        if (resultReally.resultStatus !== 1) return this.$message.error(resultReally.resultMessage)
        this.schoolList = resultReally.list || []
        this.pagination.total = resultReally.totalCount
      } catch (err) {
        console.log(err)
      }
    },
    handleSearchKeywords() {
      this.getSchoolList()
    },
    handleStatus(value) {
      this.status = value
      this.getSchoolList()
    },
    async handleExport() {
      try {
        const params = {
          provinceIds: this.treeCheckedKeys.filter((item) => item !== 'all'),
          keywords: this.searchKeywords,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        this.loading = true
        const result = await this.$http.schoolExport(params)
        this.loading = false
        const blob = new Blob([result], {
          type: 'application/vnd.ms-excel'
        })
        const objectUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = `机构运行数据${DateUtil.getNowDayTime().slice(0, 10)}.xlsx`
        a.click()
        window.URL.revokeObjectURL(objectUrl)
        this.$message.success('导出成功')
      } catch (err) {
        console.log(err)
      }
    },
    handleAdd() {
      this.addOrUpdateOrganizationalDialogFlag = true
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.getSchoolList()
    },
    handleEnable(type, schoolCode) {
      this.forbiddenStartUsingDialogType = type
      this.forbiddenStartUsingDialogFlag = true
      this.forbiddenStartUsingDialogSchoolCode = schoolCode
    },
    async getSchoolBatchSchoolByProvinceId() {
      try {
        const params = {
          provinceIds: this.treeCheckedKeys.filter((item) => item !== 'all').join(',')
        }
        const result = await this.$http.schoolBatchSchoolByProvinceId(params)
        if (result.code !== 200) return (this.selectSchoolListResult = [])
        this.selectSchoolListResult = result.rt || []
      } catch (err) {
        console.log(err)
      }
    }
  },
  async mounted() {
    await this.getProvinceTreeData()
    this.getSchoolList()
    this.getProvinceListAll()
  }
}
</script>

<style lang="scss" scoped>
.page_container {
  width: 100%;
  height: auto;
  background-color: #fff;
  text-align: left;
  display: flex;
  .tree_container {
    width: 192px;
    border-right: 1px solid #ebedee;
    .tree_title_container {
      font-size: 13px;
      color: #1e2228;
      display: flex;
      .tree_title_target {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .tree_title_sub {
        color: #1e2228;
        .number {
          color: #7a869a;
        }
      }
    }
  }
  .body_container {
    flex: 1;
    .header_container {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      border-bottom: 1px solid #ebedee;
      .title {
        font-size: 14px;
        font-weight: bold;
        color: #2c3036;
      }
      .content {
        color: #7b879a;
        .number {
          color: #7071d9;
          font-weight: bold;
        }
      }
    }
    .search_container {
      display: flex;
      justify-content: space-between;
      padding: 16px;
      align-items: center;
      .search_container_left {
        position: relative;
        ::v-deep.ant-input-affix-wrapper {
          width: 240px;
          .ant-input-suffix {
            img {
              width: 20px;
              height: 20px;
              display: block;
            }
          }
        }
      }
      .search_container_right {
        display: flex;
        .export_btn,
        .add_btn {
          height: 38px;
          border-radius: 4px;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          user-select: none;
        }
        .export_btn {
          width: 104px;
          border: 1px solid #5f60d3;
          color: #5f60d3;
          margin-right: 16px;
          &:hover {
            background-color: #f5f5f5;
          }
          &:active {
            background-color: #ffffff;
          }
        }
        .add_btn {
          width: 112px;
          background-color: #5f60d3;
          color: #ffffff;
          .icon {
            width: 16px;
            height: 16px;
            display: block;
            margin-right: 8px;
          }
          &:hover {
            background-color: #4b4cb5;
          }
          &:active {
            background-color: #5f60d3;
          }
        }
      }
    }
    .list_container {
      padding: 0 16px;
      .status_box {
        color: #1e2228;
        font-size: 14px;
        .dot {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
        .no_in_use {
          .dot {
            background: #dcdee0;
          }
        }
        .in_use {
          .dot {
            background: #00cf96;
          }
        }
        .forbidden {
          color: #d0d5db;
          .dot {
            background: #fff;
          }
        }
      }
      .action_box {
        color: #1572ff;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #0e3c82;
        }
        &:active {
          color: #1572ff;
        }
      }
    }
  }
}
</style>
